import * as React from "react";
import type { SVGProps } from "react";
const SvgEraser02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.6 21.6h17.6m-9.865-3.43H7.91l-4.018-4.018a1.005 1.005 0 0 1 0-1.416L13.936 2.692a1.004 1.004 0 0 1 1.417 0l5.022 5.022a1.004 1.004 0 0 1 0 1.416z"
    />
  </svg>
);
export default SvgEraser02;
